/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  alignItems: 'center',
}));

export const HintText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.primary.main,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
}));

export const HintBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(2),
  background: theme.palette.semantic_dark?.surface.inverseSurface,
  width: '175px',
  borderRadius: '8px',
  position: 'relative',
}));

export const HintArrow = styled('img')(() => ({
  position: 'absolute',
  bottom: '-8px',
  left: '50%',
  transform: 'translateX(-50%)',
}));
